const messages = {
  image: {
    upload_success: "イメージがアップロードされました。",
    icon_hint:
      "※きれいなアイコンにするには、正方形の画像をアップロードしてください",
    uploading: "イメージをアップロード中...",
    invalid_file_type:
      "無効なファイルタイプです\n画像ファイルをアップロードしてください。(png, jpg, jpeg)",
    drag_and_drop: "ドラッグ＆ドロップ または クリック",
    invalid_file_type_title: "無効なファイルタイプ",
  },
  csv: {
    do_not_close:
      "このページから離れたり、再読み込みを行ったりしないようお願いいたします。",
    hint: " ※ ユーザーにアプリケーションを追加する際、YOBELY または KAKELYから選択できます。",
    hint_example: "※ 例： 利用アプリ",
    available_apps: "KAKELYのみ → 1\nYOBELYのみ → 2\n両方利用 → 1,2",
    app_instruction_title: "一括登録方法",
    app_instruction_add_multiple:
      "※ KAKELYとYOBELYを利用する場合は「1,2」と入力してください。",
    instructions_csv_create_edit_user:
      "※ Excelで直接CSVファイルを開くと、先頭が「0」で始まる数値（例：電話番号、コード番号など）が自動的に「数値」として扱われ、先頭の「0」が消えます。",
    instructions_opening_csv_file:
      "　Excelのメニューの「ファイル」→「オプション」→「データ」→「自動データ変換」→「先頭のゼロを削除して数値に変換する」のチェックを外してください。",
    instructions_opening_csv_file_cont:
      "　その上で、CSVをダウンロードし直し、再度csvファイルを開いて下さい。",
    instructions_csv_version_warning:
      "※ Excelのバージョンによって表示名や表示箇所が異なることがございます。",
    user_instruction_title: "Excelでのファイル閲覧に関する注意",
    users_warning:
      "※ 注意：社内電話帳の更新および削除は元に戻せません。慎重に操作してください。",
    contacts_instruction_title: "社外電話帳管理CSVの操作方法",
    contacts_instruction_title_internal: "一括登録方法",
    department_instruction_title: "部署管理CSVの操作方法",
    instructions_contact_id_create:
      "※ IDが「0」または空欄の場合、新規が作成されます。",
    instructions_contact_id_edit:
      "※ IDが既存の値の場合、そのIDの社外電話帳情報が更新されます。",
    instructions_contact_delete:
      "※ 削除フラグ「削除」が「1」の場合、指定したIDの社外電話帳が削除されます。",
    contacts_warning:
      "※ 注意：社外電話帳の更新および削除は元に戻せません。慎重に操作してください。",
    departments_warning:
      "※ 注意：部署の更新および削除は元に戻せません。慎重に操作してください。",
    contacts_warning_internal:
      "※ 注意：社内電話帳の更新および削除は元に戻せません。慎重に操作してください。",
    headers_hint_download:
      "※ 1行目はヘッダー行となりますので削除をせずにアップロードしてください。",
    headers_hint_keep_headers:
      "※ 2行目はサンプルの為、削除後に入力してください",
    set_zero_create_user:
      "※ ユーザーIDが「0」の場合、新規ユーザーが作成されます。",
    id_exists_auto_update:
      "※ ユーザーIDが既存の値の場合、そのIDのユーザー情報が更新されます。",
    delete_on_flag:
      "※ 削除フラグ「削除」が「1」の場合、指定したIDのユーザーが削除されます。",
    headers_on_first_line:
      "※ 1行目はヘッダー行となりますので削除をせずにアップロードしてください。",
    second_line_sample: "※ 2行目はサンプルの為、削除後に入力してください。",
    set_zero_create_department:
      "※ 部署IDが「0」の場合、新規部署が作成されます。",
    set_department_code_to_link_parents:
      "※ 部署コードを設定することで、親部署と紐づけができます。",
    delete_department_on_flag:
      "※ 削除フラグ「削除」が「1」の場合、指定したIDの部署が削除されます。",
    warning_using_old_files:
      "※古いCSVファイルを使用すると、最新のユーザー情報が失われる可能性があります。\n アップロードの際は、直前に最新データをダウンロードしたCSVをご利用ください。",
  },
  password: {
    success: "パスワードが正常に変更されました。",
    init_success: "パスワードが初期化されました。",
    policy_information:
      "値は英字 (A-Za-z)、数字 (0-9)、アンダースコア (_) のみを含み、5文字以上64文字以内である必要があります。",
  },
  notification: {
    restart: "お知らせが再配信されました。",
    stop: "お知らせが停止されました。",
  },
  keycloak: {
    token_authed: "トークンが認証されました",
    wait_for_init:
      "Keycloakがまだ初期化されていません。しばらくお待ちください...",
  },
  user: {
    deleted: (count) => `${count}の電話帳が削除されました`,
    uploaded: (createdCount, failedCount) =>
      `${
        failedCount > 0
          ? `${failedCount}件のユーザーの情報が処理に失敗しました。`
          : ""
      }${
        createdCount > 0
          ? `${createdCount}件のユーザーの情報が正常に処理されました。`
          : ""
      }`,
    single_user_uploaded: () => "1件のユーザーの情報が正常に処理されました。",
    skipped_deletion: (userNum) =>
      `${userNum} 件のWEBユーザーアカウントが削除されました`,
    no_cards: "名刺データが登録されていません。",
    personal_tel_or_company_tel_required:
      "会社電話番号もしくは個人電話番号のどちらかは必須です。",
    loading: "ユーザ情報を読み込み中。少々を待ちください",
    duplicate_select: "更新対象を選択してください。",
  },
  tenant: {
    unable_to_edit_hazum: "テナントのYOBELYの設定は編集できません。",
    cannot_add_license_after_creation:
      "現在、テナント作成後にYOBELYライセンスを追加することはできません。",
    create_loading_text:
      "テナントの処理には時間がかかる場合があります。しばらくお待ちください。",
  },
  generic: {
    show_error: "エラーを表示",
    error_modal_title: "エラー表示",
    password_policy: "英字大文字、小文字、数字、記号を全て含み、8文字以上",
  },
  kakely: {
    loading: "電話帳情報を読み込み中。少々を待ちください",
  },
};

export default messages;
